import { WHATSAPP_TEMPLATE_BUTTON_TYPES } from 'cpool-constants';
import { z } from 'zod';

// Resolved/outbound: a sent URL button always carries its final url, no hasDynamicSuffix. Array position is the button index.
export const schemaChatTemplateButton = z.discriminatedUnion('type', [
    z.object({ text: z.string().min(1), type: z.literal(WHATSAPP_TEMPLATE_BUTTON_TYPES.QUICK_REPLY) }),
    z.object({
        text: z.string().min(1),
        type: z.literal(WHATSAPP_TEMPLATE_BUTTON_TYPES.URL),
        url: z.string().min(1),
    }),
    z.object({
        phoneNumber: z.string().min(1),
        text: z.string().min(1),
        type: z.literal(WHATSAPP_TEMPLATE_BUTTON_TYPES.PHONE_NUMBER),
    }),
    // Unreachable in practice (blocks the template before send) — modeled so the mapping stays total.
    z.object({
        metaType: z.string().min(1),
        text: z.string(),
        type: z.literal(WHATSAPP_TEMPLATE_BUTTON_TYPES.UNKNOWN),
    }),
]);

export type Schema_ChatTemplateButton = z.infer<typeof schemaChatTemplateButton>;
